import { render, staticRenderFns } from "./date-range-picker.vue?vue&type=template&id=3645d83a&scoped=true&"
import script from "./date-range-picker.vue?vue&type=script&lang=js&"
export * from "./date-range-picker.vue?vue&type=script&lang=js&"
import style0 from "./date-range-picker.vue?vue&type=style&index=0&id=3645d83a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645d83a",
  null
  
)

export default component.exports